import styled from '@emotion/styled';

const Column = styled('div')`
	flex-basis: ${props => props.basis};
	position: relative;

	${props => (props.input ? props.theme.column || '' : '')}
`;

export default Column;
